var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmailSend = function SvgEmailSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.266 6.934h-16m0 0c-1.184 0-2.133.949-2.133 2.133v13.867c0 1.184.95 2.133 2.133 2.133m0-18.133h23.467c1.184 0 2.133.949 2.133 2.133v7.648-.181 6.4c0 1.184-.95 2.133-2.133 2.133H4.266m0 0h18.667"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m20.471 15.996-4.47 4.267-4.468-4.265m8.938-.002 6.355-6.066m-6.355 6.066 6.355 6.067m-15.293-6.065L5.176 9.93m6.357 6.068-6.357 6.068"
  })));
};
export default SvgEmailSend;